import React, { useMemo } from "react";
import { getLocalizedString } from "@icarius-localization/strings";
import MenuItem from "./menuItem";
import { List } from "@material-ui/core";
import { useSelector } from "react-redux";
import { getAlertsAmount, getUserRole, getDigitalDocumentsAmount } from "@icarius-app/selectors";
import DEFAULT_LIST_ITEMS from "./defaultListItem";

const DrawerDefaultItems = (props) => {
    const { handleOpenItem, availablePaths, showChangeSocietyMenuItem, showChangeRoleMenuItem } = props;

    const digitalDocumentsQuantity = useSelector(getDigitalDocumentsAmount);
    const alertsAmount = useSelector(getAlertsAmount);
    const role = useSelector(getUserRole);

    const defaultItemsToShow = useMemo(() => {
        return DEFAULT_LIST_ITEMS.filter((item) => {
            return (
                ((item.title === "changeRole" && showChangeRoleMenuItem) || item.title !== "changeRole") &&
                ((item.title === "changeSociety" && showChangeSocietyMenuItem) || item.title !== "changeSociety") &&
                (!item.roles || item.roles.includes(role)) &&
                availablePaths?.includes(item.path)
            );
        });
    }, [showChangeRoleMenuItem, showChangeSocietyMenuItem, role, availablePaths]);

    const getDefaultItemsAmount = (item) => {
        if (item.title === "alerts") return alertsAmount;
        if (item.title === "digitalDocuments") return digitalDocumentsQuantity;
        return null;
    };

    return (
        <List key={"default-menu"}>
            {defaultItemsToShow.map((item, index) => (
                <MenuItem
                    key={index}
                    icon={item.icon}
                    label={getLocalizedString(item.title)}
                    amount={getDefaultItemsAmount(item)}
                    onClick={() => handleOpenItem(item)}
                />
            ))}
        </List>
    );
};

export default DrawerDefaultItems;
